module.exports = __webpack_public_path__ + "static/img/aboutUs12.22f237b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs12.jpg
// module id = 1364
// module chunks = 1